<template>
  <section class="side-nav" :class="{'is-active': isNavOpen}">
    <h2 class="side-nav__ttl" v-if="isLogin">{{nameUser}}</h2>
    <h2 class="side-nav__ttl" v-else>
      <router-link :to="{ name: 'loginHome'}">
        サインイン
      </router-link>
    </h2>
    <div class="side-nav__main">
      <nav class="radio-nav">
        <ul>
          <li class="radio-nav__list">
            <span @click="pageChangeNavToggle">
              <router-link :to="{ name: 'rankingHome'}">
                ランキング
              </router-link>
            </span>
          </li>
          <li class="radio-nav__list">
            <span @click="pageChangeNavToggle">
              <router-link :to="{ path: '/categories/category_word' }">
                ジャンル
              </router-link>
            </span>
          </li>
          <!-- <li class="radio-nav__list">
            <span @click="pageChangeNavToggle">
              <router-link :to="{ name: 'UnlimitedPlus' }">
                アンリミテッドプラス
              </router-link>
            </span>
          </li>-->
          <!-- <li class="radio-nav__list">
            <span @click="pageChangeNavToggle">
              <router-link :to="{ name: 'premiumHome'}">
                プレミアム
              </router-link>
            </span>
          </li> -->
        </ul>
      </nav>
      <section class="side-account">
        <h3 class="side-account__ttl">アカウント</h3>
        <nav>
          <ul class="side-account-nav">
            <li @click="pageChangeNavToggle">
              <router-link :to="{ name: 'settingHome'}">
                設定
              </router-link>
            </li>
            <li @click="pageChangeNavToggle">
              <router-link :to="{ name: 'historyHome'}">
                購入履歴
              </router-link>
            </li>
            <li @click="pageChangeNavToggle">
              <router-link :to="{ name: 'settingPaymentWay'}">
                お支払い方法
              </router-link>
            </li>
            <li @click="pageChangeNavToggle">
              <a href="https://www.globeejapan.com/faq.html" target="_blank">
                FAQ
              </a>
            </li>
            <li v-if="isLogin">
              <a href="javascript:void(0);" @click="logout">ログアウト</a>
            </li>
            <li v-else>
              <span @click="pageChangeNavToggle">
                <router-link :to="{ name: 'loginHome'}">
                  ログイン
                </router-link>
              </span>
            </li>
          </ul>
        </nav>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  props: ["isNavOpen"],
  computed: {
    nameUser() {
      return window.localStorage.getItem(['userName']);
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  methods: {
    pageChangeNavToggle() {
      this.$store.dispatch("navToggle", false);
    },
    logout() {
      this.$store.dispatch("navToggle", false);
      this.$store.dispatch("logout").then(() => {
        location.href = this.$route.path;
      });
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/Side.vue